import React from "react";
import { connect } from "react-redux";

function HelpTab() {
    return (
        <div className="p-4 bg-gray-50 rounded-2xl shadow-sm text-gray-800 leading-relaxed">
            <h6 className="text-lg font-semibold mb-2 text-gray-700">
                Help — Task Generation
            </h6>
            <p className="mb-2">
                This option will create <strong>Tasks</strong> for use by RF handhelds.
            </p>
            <p>
                Tasks can only be created from the 
                <strong> “Pending” </strong> or 
                <strong> “Ready” </strong> stages.
            </p>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(HelpTab);
